import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button, ButtonType } from '../Button';
import { Modal } from '../Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRenew: () => void;
  expiresOn?: string;
}

export const BackgroundCheckRenewModal = ({
  isOpen,
  onClose,
  onRenew,
  expiresOn,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('components.modals.backgroundCheckRenew.title')}
      className='w-full max-w-md'
      footer={
        <>
          <Button buttonType={ButtonType.tertiary} onClick={onClose}>
            {t('components.modals.backgroundCheckRenew.later')}
          </Button>
          <Button buttonType={ButtonType.primary} onClick={onRenew}>
            {t('components.modals.backgroundCheckRenew.renewNow')}
          </Button>
        </>
      }
    >
      <p>
        {expiresOn ? (
          <Trans
            i18nKey='components.modals.backgroundCheckRenew.expiresOn'
            values={{ date: expiresOn }}
            components={{ b: <b /> }}
          />
        ) : (
          t('components.modals.backgroundCheckRenew.expiringSoon')
        )}
        {' '}
        {t('components.modals.backgroundCheckRenew.body')}
      </p>
    </Modal>
  );
};
